'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" {...props}><path fill="currentColor" fillRule="evenodd" d="M0 3.667A3.667 3.667 0 0 1 3.667 0h14.666A3.667 3.667 0 0 1 22 3.667V13.75a3.667 3.667 0 0 1-3.667 3.666H3.667A3.667 3.667 0 0 1 0 13.75zm3.667-1.834c-1.013 0-1.834.821-1.834 1.834V13.75c0 1.012.821 1.833 1.834 1.833h14.666c1.013 0 1.833-.82 1.833-1.833V3.667c0-1.013-.82-1.834-1.833-1.834z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M9.507 15.649c.47.188.699.721.51 1.191l-1.833 4.584a.917.917 0 1 1-1.702-.681l1.833-4.584a.917.917 0 0 1 1.192-.51M12.493 15.649a.917.917 0 0 0-.51 1.191l1.832 4.584a.917.917 0 1 0 1.703-.681l-1.834-4.584a.917.917 0 0 0-1.191-.51" clipRule="evenodd" /></svg>;
const IconTv = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconTv;